import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CONTACT_TYPE_MAIL, CONTACT_TYPE_PHONE } from '../../defaults/ContactTypes';
import { MailIcon, PhoneIcon, StyledSwitch } from './styles';

const SwitchContactType = ({ onChange, contactType }) => {
 
  const [stateContactType, setStateContactType] = useState(contactType);

  const handleChange = () => {

    let newContactType = 
      stateContactType === CONTACT_TYPE_MAIL
      ? CONTACT_TYPE_PHONE
      : CONTACT_TYPE_MAIL;

    setStateContactType(newContactType);
    onChange(newContactType);
  }

  const isMail = stateContactType === CONTACT_TYPE_MAIL;
  const isPhone = stateContactType === CONTACT_TYPE_PHONE;
 
  return(
    <StyledSwitch
      checked={isMail}
      checkedIcon={
        <PhoneIcon selected={isPhone} />
      }
      onChange={handleChange}
      uncheckedIcon={
        <MailIcon selected={isMail} />
      }
    />
  )
};

SwitchContactType.defaultProps = {
  contactType: CONTACT_TYPE_PHONE,
};

SwitchContactType.propTypes = {
  contactType: PropTypes.oneOf([CONTACT_TYPE_MAIL, CONTACT_TYPE_PHONE]),
  onChange: PropTypes.func.isRequired,
};

export default SwitchContactType;


// WEBPACK FOOTER //
// ./src/components/SwitchContactType/index.js